<div fxLayout="column" fxFill class="my-active-calls">
  <button type="button" mat-icon-button class="btn-close" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
  <ng-container *ngIf="standbyCall && !hasUnansweredCall()">
    <call-standby [call]="standbyCall"></call-standby>
    <mat-divider></mat-divider>
  </ng-container>
  <call-active *ngIf="activeCall" [call]="activeCall"></call-active>
</div>
